export default __webpack_public_path__ + "static/media/accountability.4b444512.png";